import React, { createContext, useEffect, useState } from "react";

import { StandardsResponse } from "../../api/master-api/lookups/StandardsResponse";
import { useMasterLookupsApi } from "../../api/master-api/lookups/useMasterLookupsApi";
import { Standard } from "../../types/Standard";

interface IStandardsDataContext {
    standards: Standard[];
    isLoading: boolean;
}

export const StandardsDataContext = createContext<IStandardsDataContext>({
    isLoading: false,
    standards: []
});

type StandardsDataProviderProps = React.PropsWithChildren<unknown>;

export const StandardsDataProvider: React.FunctionComponent<StandardsDataProviderProps> = ({
    children
}: StandardsDataProviderProps) => {
    const [standards, setStandards] = useState<Standard[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getStandards } = useMasterLookupsApi();

    useEffect(() => {
        setIsLoading(true);
        getStandards().then((response: StandardsResponse) => {
            setStandards(response.items);
            setIsLoading(false);
        });
    }, []);

    return <StandardsDataContext.Provider value={{ standards, isLoading }}>{children}</StandardsDataContext.Provider>;
};
